module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero5.png?1810540c";